import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import AllCards from './AllCards';

const UsersCardssContain = () => {
  return (
    <Container fluid className='user-card'>
      <Breadcrumbs pageTitle='User Cards' parent='Users' title='User Cards' />
      <Row>
        <AllCards />
      </Row>
    </Container>
  );
};
export default UsersCardssContain;
